/**
 * Link to a Run
 */

// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React from 'react';

import {getColorName} from '../../util/colors';
import {run as runUrl} from '../../util/urls';
// @todo: Migrate to 'Link' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Link} from './Link';
import * as S from './LinkRun.styles';
import {getDefaultColor} from './utils';

type LinkRunProps = {
  entityName: string;
  projectName: string;
  name: string; // e.g. "dk6pv7ri"
  displayName: string; // e.g. "stellar-galaxy-30"

  // If no color information is passed, the circular indicator will not be shown.
  // If it is provided, make sure you are respecting color overrides by providing
  // correct customRunColors. Color in this component is readonly.
  defaultColor?: string;
  defaultColorIndex?: number;
  customRunColors?: Record<string, string>;
};

export type ColorIndicatorProps = {
  name: string;
  customRunColors: Record<string, string>;
  defaultColor: string | undefined;
  defaultColorIndex?: number;
};

export const getRunColor = (
  name: string,
  customRunColors: Record<string, string>,
  defaultColor: string | undefined,
  defaultColorIndex: number | undefined
): string => {
  return (
    customRunColors[name] ??
    defaultColor ??
    getDefaultColor(defaultColorIndex, name)
  );
};

// Circle showing the color associated with a run.
// We make it a separate component for reuse in places where
// we don't want the run name to be a link to the run's page.
export const ColorIndicator = ({
  name,
  customRunColors,
  defaultColor,
  defaultColorIndex,
}: ColorIndicatorProps) => {
  const backgroundColor = getRunColor(
    name,
    customRunColors,
    defaultColor,
    defaultColorIndex
  );
  return (
    <Tooltip
      content={getColorName(backgroundColor)}
      trigger={<S.ColorIndicator backgroundColor={backgroundColor} />}
    />
  );
};

export const LinkRun = ({
  entityName,
  projectName,
  name,
  displayName,
  defaultColor,
  defaultColorIndex,
  customRunColors,
}: LinkRunProps) => {
  const urlParams = {
    entityName,
    projectName,
    name,
  };
  const urlRun = runUrl(urlParams);

  return (
    <div style={{display: 'inline-flex', alignItems: 'center', width: '100%'}}>
      {customRunColors != null && (
        <ColorIndicator
          name={name}
          customRunColors={customRunColors}
          defaultColor={defaultColor}
          defaultColorIndex={defaultColorIndex}
        />
      )}
      <S.RunName>
        <Link to={urlRun}>{displayName}</Link>
      </S.RunName>
    </div>
  );
};
